/**
 * DEPRECATED, ASPECT RATIOS MUST BE DEFINED IN API CONFIG
 * Available aspect ratios throughout the application.
 * @type {{}}
 */
export const aspectRatios = {
  /**
   * @typedef {{}} AspectRatioCard
   * @property {string} alias
   * @property {number} width
   * @property {number} height
   */
  '1-1-aspect-ratio': {
    alias: '1-1-aspect-ratio',
    width: 1,
    height: 1,
  },
  '4-3-aspect-ratio': {
    alias: '4-3-aspect-ratio',
    width: 4,
    height: 3,
  },
  '3-4-aspect-ratio': {
    alias: '3-4-aspect-ratio',
    width: 3,
    height: 4,
  },
  '9-16-aspect-ratio': {
    alias: '9-16-aspect-ratio',
    width: 9,
    height: 16,
  },
  '16-9-aspect-ratio': {
    alias: '16-9-aspect-ratio',
    width: 16,
    height: 9,
  },
  '21-9-aspect-ratio': {
    alias: '21-9-aspect-ratio',
    width: 21,
    height: 9,
  },
  '9-21-aspect-ratio': {
    alias: '9-21-aspect-ratio',
    width: 9,
    height: 21,
  },
  '8-9-aspect-ratio': {
    alias: '8-9-aspect-ratio',
    width: 8,
    height: 9,
  },
  'facebook-aspect-ratio': {
    alias: 'facebook-aspect-ratio',
    width: 300,
    height: 157,
  },
  'twitter-aspect-ratio': {
    alias: 'twitter-aspect-ratio',
    width: 400,
    height: 224,
  },
  'source-aspect-ratio': {
    alias: 'source-aspect-ratio',
    width: 0,
    height: 0,
  },
};

export const availableAspectRatios = Object.keys(aspectRatios);
